// extracted by mini-css-extract-plugin
export default {"root":"gDvtvH1VEHTgPoePthw7","close-page":"FcqeXi9hB7IP7xSHMGBW"};